<template>
  <div class="">
    <headers></headers>
    <banners></banners>
    <navigations></navigations>
    <router-view />
    <tabbers></tabbers>
  </div>
</template>

<script setup>
import headers from "@/components/headers.vue";
import banners from "@/components/banners.vue";
import navigations from "@/components/navigations.vue";
import tabbers from "@/components/tabbers.vue";
import { onMounted, ref, computed, watch, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
const router = useRouter();
const { proxy } = getCurrentInstance(); //关键代码
import { useStore } from "vuex";
const store = useStore();
const bannersLists = ref([]);


  
const getTypeLists = () => {
  proxy
    .request("news/projecttype", {})
    .then((res) => {
      store.commit("setprojecttype", res.data);
    });
  proxy
    .request("news/newcenterindex", {})
    .then((res) => {
      store.commit("setnewcenterindex", res.data);
    });
};

const getbanners = () => {
  proxy
    .request("news/navlist", {})
    .then((res) => {
      store.commit("setbannersLists", res.data);
      bannersLists.value = res.data
    });
};
const imgonload=(ins)=>{
  if(ins>bannersLists.value.length-1){

  }else{
    var newImg = new Image();
    newImg.src = bannersLists.value[ins].images;
    newImg.onload = function(){
      imgonload(ins+1)
    }
  }
}

getTypeLists()
getbanners()

const ispc = ref(true);
const setHtmlFontSize = () => {
  var windowWidth = document.documentElement.offsetWidth;
  var htmlFontSize = 12;
  if (windowWidth > 750) {
    ispc.value = true;
    htmlFontSize = 12;
  } else {
    ispc.value = false;
    htmlFontSize = windowWidth / 750;
  }
  store.commit("setispc", ispc.value);
  document.querySelector("html").style.fontSize = htmlFontSize + "px";
};
setHtmlFontSize();
window.addEventListener("resize", setHtmlFontSize);
onMounted(() => {
  document.dispatchEvent(new Event("render-event"));
});
</script>

<style>
	@import '@/utils/swiper-bundle.min.css';

body {
  margin: 0;
  padding: 0;
  background: #ffffff;
}
*{
  letter-spacing: 2px !important;
  word-spacing: 2px !important;
}
.spacing {
  letter-spacing: 2px !important;
  word-spacing: 2px !important;
}
.spacing1 {
  letter-spacing: 1px !important;
  word-spacing: 1px !important;
}
.spacing2{
  letter-spacing: 3px !important;
  word-spacing: 3px !important;
}
.spacing *{
  letter-spacing: 2px !important;
  word-spacing: 2px !important;
}
.spacing1 *{
  letter-spacing: 1px !important;
  word-spacing: 1px !important;
}
.spacing2 *{
  letter-spacing: 3px !important;
  word-spacing: 3px !important;
}
.nospacing{
  letter-spacing: 0 !important;
  word-spacing: 0 !important;
}
@media screen and (max-width: 768px) {
  .bodys{
    width: calc(100% - 60rem);
    margin: 0 auto;
  }
  .swiper{
    --swiper-theme-color: #ff6600;/* 设置Swiper风格 */
    --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
    --swiper-navigation-size: 30rem;/* 设置按钮大小 */
  }
  .swiperse .swiper-button1{
    width: 45rem !important;
    height: 45rem !important;
    background: #999;
    border-radius: 50%;
    overflow: hidden;
  }

  .htmlse{
    font-size: 28rem;
  }
  .htmlse18{
  }
  .htmlse20{
    font-size: 20rem;
    line-height: 28rem;
  }
  .htmlsem p{
    margin: 0 0 10rem 0 !important;
  }
  .htmlse img{
    max-width: 100% !important;
  }
  
  .abutse_titles{
    font-weight: bold;
    font-size: 40rem;
    color: #075785;
    margin-bottom: 50rem;
  }
  .abutse_titles_lefts{
    margin-right: 10rem;
  }

  
  .projelist_items {
    width: calc(50% - 10rem);
    margin: 0 0 30rem 0;
    background: #F8F8F8;
  }
  .projelist_items_images{
    height: 210rem;
  }
  .projelist_items_texts {
    margin: 10rem;
    font-size: 24rem;
    line-height: 36rem;
    height: 72rem;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

    
  .titlese{
    padding: 0 0 50rem;
    margin: 0 0 40rem;
  }
  .titlese::after{
    content: "";
    width: 46rem;
    height: 4rem;
  }
  .titlese_enlis{
    font-size: 30rem;
  }
  .titlese_texts{
    font-size: 40rem;
  }

  
  .honores_typeList_blocks::after,
  .honores_typeList_blocks::before,
  .honores_typeList_blocks1::after,
  .honores_typeList_blocks1::before{
    content: "";
    width: 16rem;
    height: 24rem;
  }
}
@media screen and (min-width: 768px) {
  
  .swiper{
    --swiper-theme-color: #ff6600;/* 设置Swiper风格 */
    --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
    --swiper-navigation-size: 20px;/* 设置按钮大小 */
  }
  .swiperse .swiper-button1{
    width: 35px !important;
    height: 35px !important;
    background: #999;
    border-radius: 50%;
    overflow: hidden;
  }

  .bodys{
    width: calc(100% - 20px);
    margin: 0 auto;
  }
  .htmlse16{
    font-size: 16px;
  }
  .htmlse18{
    font-size: 18px;
    line-height: 28px;
  }
  .htmlse20{
    font-size: 20px;
    line-height: 28px;
  }
  .htmlsem p{
    margin: 0 0 6px 0 !important;
  }
  .htmlse img{
    max-width: 100% !important;
  }
  
  .abutse_titles{
    padding-top: 20px;
    font-weight: bold;
    font-size: 40px;
    color: #075785;
    margin-bottom: 60px;
    display: flex;
    justify-content: center;
  }
  .abutse_titles_lefts{
    margin-right: 10px;
  }

  
  .projelist_items {
    width: calc(33% - 20px);
    margin: 0 20px 10px 0;
    background: #F8F8F8;
  }
  .projelist_items_images{
    width: 100%;
    height: 240px !important;
  }
  .projelist_items_texts {
    margin: 10px;
    font-size: 16px;
    line-height: 22px;
    height: 44px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }


  .titlese{
    padding: 0 0 40px;
    margin: 0 0 40px;
  }
  .titlese::after{
    content: "";
    width: 45px;
    height: 4px;
  }
  .titlese_enlis{
    font-size: 30px;
  }
  .titlese_texts{
    font-size: 40px;
  }

  
  .honores_typeList_blocks::after,
  .honores_typeList_blocks::before,
  .honores_typeList_blocks1::after,
  .honores_typeList_blocks1::before{
    content: "";
    width: 12px;
    height: 14px;
  }
}
@media screen and (min-width: 768px) and (max-width: 900px) {
}
@media screen and (min-width: 900px) and (max-width: 1200px) {
  .bodys{
    width: 95%;
    margin: 0 auto;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1400px) {
  .bodys{
    width: 1100px;
    margin: 0 auto;
  }
}
@media screen and (min-width: 1400px) {
  .bodys{
    width: 1200px;
    margin: 0 auto;
  }
}
.scrollbars{
  display: flex;
  width: fit-content;
  padding: 0 0 15px;
}

  .htmlse{
    /* text-indent:2em; */
    /* line-height: 2.5; */
  }





  .titlese{
    text-align: center;
    position: relative;
  }
  .titlese_enlis{
    position: absolute;
    bottom: 0;
    left: 50%;
    font-weight: bold;
    color: #E9E9E9;
    /* background: -webkit-linear-gradient(top, #E9E9E9 20%, transparent); */
    background: -webkit-linear-gradient(top,  transparent 20%, #E9E9E9);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    transform: translate(-50%,-60%);
  white-space: nowrap;
  }
  .titlese_texts{
    font-weight: bold;
    color: #075785;
    text-align: center;
    position: relative;
    z-index: 10;
  }
  .titlese1::after{
    background: #ffffff;
  }
  .titlese::after{
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    background: #075785;
    transform: translate(-50%,0);
  }
  
  .honores_typeList_blocks::after,
  .honores_typeList_blocks::before,
  .honores_typeList_blocks1::after,
  .honores_typeList_blocks1::before{
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    background: #F86C0A;
    transform: translate(0,-40%);
  }

  .honores_typeList_blocks1::after,
  .honores_typeList_blocks1::before{
    right: -5%;
    left: auto;
  }
  .honores_typeList_blocks::before,
  .honores_typeList_blocks1::before{
    background: #075785;
    transform: translate(-40%,-60%);
  }

.fw_bold {
  font-weight: bold;
}
.bg_1 {
  background: rgba(11,34,66,.75);
}
.bg_2 {
  background: #0b2242;
}
.bg_3 {
  background: rgba(28,67,132,.75);
}
.bg_0000006 {
  background: rgba(0, 0, 0, 0.6);
}
.bg_0000002 {
  background: rgba(0, 0, 0, 0.2);
}
.bg_999999 {
  background: #999999;
}
.bg_ffffff {
  background: #ffffff;
}
.bg_F8F8F8 {
  background: #f8f8f8;
}
.bg_F6F6F6 {
  background: #F6F6F6;
}
.bg_F4F4F4 {
  background: #F4F4F4;
}
.bg_DDDDDD {
  background: #DDDDDD;
}
.bg_EBEBEB {
  background: #EBEBEB;
}
.bg_1C4384 {
  background: #1C4384;
}
.bg_085688 {
  background: #085688;
}
.bg_F86C0A {
  background: #F86C0A;
}
.c_333333 {
  color: #333333;
}
.c_666666 {
  color: #666666;
}
.c_999999 {
  color: #999999;
}
.c_163f74 {
  color: #163f74;
}
.c_ffffff {
  color: #ffffff;
}

.none {
  display: none;
}
.block {
  display: block;
}
.flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.flex-col-center {
  align-items: center;
}
.flex-col-stretch {
  align-items: stretch;
}
.flex-col-top {
  align-items: flex-start;
}
.flex-col-bottom {
  align-items: flex-end;
}
.flex-row-center {
  justify-content: center;
}
.flex-row-left {
  justify-content: flex-start;
}
.flex-row-right {
  justify-content: flex-end;
}
.flex-row-between {
  justify-content: space-between;
}
.flex-row-around {
  justify-content: space-around;
}
.flex-col {
  flex-direction: column;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-4 {
  flex: 4;
}
.flex-5 {
  flex: 5;
}
.flex-6 {
  flex: 6;
}
input {
  border: none;
  outline: none;
  background: transparent;
}

.fixed {
  position: fixed;
}
.relative {
  position: relative;
}
.absolute {
  position: absolute;
}
.at0 {
  top: 0;
}
.at100 {
  top: 100;
}
.al0 {
  left: 0;
}
.ar0 {
  right: 0;
}
.ab0 {
  bottom: 0;
}
.zi10 {
  z-index: 10;
}
.zi20 {
  z-index: 20;
}
.zi700 {
  z-index: 700;
}
.w100 {
  width: 100%;
}
.w100vw {
  width: 100vw;
}
.h80 {
  height: 80%;
}
.h100 {
  height: 100%;
}
.mw100 {
  min-width: 100%;
}
.mh100 {
  min-height: 100%;
}
.msw100 {
  max-width: 100%;
}
.msh100 {
  max-height: 100%;
}

.tran_r180{
  transform: rotate(180deg);
}
.margin3:nth-child(3n){
	margin-right: 0 !important;
}
.mar0:nth-last-child(1){
  margin: 0 !important;
}

.marauto{
  margin: 0 auto;
}

.cur_po {
  cursor: pointer;
}
.ovhi {
  overflow: hidden;
}
.selector {
  white-space: nowrap;
}
.text-ellipsis-1 {
  white-space: nowrap; /* 保持文本在一行，不换行 */
  overflow: hidden; /* 隐藏超出容器的内容 */
  text-overflow: ellipsis; /* 超出部分显示为省略号 */
}
.text-ellipsis-2 {
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-ellipsis-3 {
  overflow: hidden;
  -webkit-line-clamp: 3;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
.text-center {
  text-align: center;
}

.scrolsimga {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.scrolsimga1 {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
/* .icons1 {
  background-image: url("@/assets/icons1.png");
}
.icons2 {
  background-image: url("@/assets/icons2.png");
}
.icons3 {
  background-image: url("@/assets/icons3.png");
}
.icons4 {
  background-image: url("@/assets/icons4.png");
}
.slices1 {
  background-image: url("@/assets/slices1.png");
}
.slices2 {
  background-image: url("@/assets/slices2.png");
}
.bors1 {
  background-image: url("@/assets/bors1.png");
}
.bors2 {
  background-image: url("@/assets/bors2.png");
}
.qiye {
  background-image: url("@/assets/qiye.png");
}
.aboutse {
  background-image: url("@/assets/aboutse.png");
} */

.ggimgs {
  max-width: 100%;
}
.tr50 {
  transform: translate(-10%, 20%);
}
.fs-medium {
  font-size: medium !important;
}


.hover1:hover .hover1_blocks{
  transform: scale(1.08);
}
.hover1:hover .hover1_blocks1{
  transform: scale(1.13);
}
.hover1:hover .color1{
 color: #075785;
}
.hover1:hover .color2{
 color: #FFFFFF;
}
.hover1:hover .bg1{
 background: #075785;
}
.hover2:hover{
 background: #075785;
}
.hover2:hover .color1{
 color: #FFFFFF;
}
.hover2:hover .color2{
 color: rgba(255, 255, 255, 0.4);
}
.hover2:hover .color3{
 color: #BCBFD7;
}

.hover2:hover .blocks1{
  transform: scale(1.1);
}
.hcolor1:hover{
 color: #075785;
}
.hcolor2:hover{
 color: #BCBFD7;
}


</style>
